module.exports = __webpack_public_path__ + "static/media/2015_conf_Personal_Design_X.6c051d48.png";